// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--y3Xfy","inner":"_0fce717cdb--inner--nD6VO","description-wrapper":"_0fce717cdb--description-wrapper--uBxbR"};